import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { Crisp } from "crisp-sdk-web";

window.addEventListener("load", () => {
  const headerDOM = document.querySelector("header.header");
  const headerItems = headerDOM.querySelectorAll("nav a");
  const headerRelatedSections = document.querySelectorAll([
    "#about",
    "#services",
    "#work",
  ]);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        const relatedNavItem = headerDOM.querySelector(`nav a[href="#${id}"]`);
        headerItems.forEach((item) => {
          item.classList.remove("is-active");
        });
        relatedNavItem.classList.add("is-active");
      }
    });
  });

  headerRelatedSections.forEach((section) => {
    observer.observe(section);
  });

  const header = gsap.timeline({
    scrollTrigger: {
      trigger: headerDOM,
      start: "top top-=10px",
      end: "100px",
      scrub: 0.45,
    },
  });
  const headerInitialWidth = headerDOM.getBoundingClientRect().width;

  header.fromTo(
    headerDOM,
    {
      width: headerInitialWidth,
      backdropFilter: "blur(0px)",
      boxShadow: "0 0 0 rgba(0, 0, 0, 0)",
      background: "rgba(44, 85, 58, 0)",
    },
    {
      width: 886,
      backdropFilter: "blur(10px)",
      boxShadow: "0px 0px 44px 0px rgba(0, 0, 0, 0.15)",
      background: "rgba(44, 85, 58, 1)",
    }
  );

  const cover = gsap.timeline();
  cover
    .fromTo(
      ".cover--main",
      {
        opacity: 0,
        x: -5,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power4.inOut",
      }
    )
    .fromTo(
      ".cover--shadow",
      {
        x: -20,
        y: -20,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.inOut",
      },
      "-=0.75"
    )
    .fromTo(
      ".cover--x",
      {
        opacity: 0,
        rotate: -45,
        scale: 0.6,
      },
      {
        opacity: 1,
        duration: 1.5,
        rotate: 0,
        scale: 1,
        ease: "power4.inOut",
      },
      0
    ).fromTo('.about', {
        opacity: 0,
        y: 20
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power4.inOut'
      }, '-=1.1'
    );

  const flower = gsap.timeline({
    scrollTrigger: {
      trigger: ".cover--x",
      start: "top bottom",
      end: "bottom top-=20%",
      scrub: 1,
    },
  });

  flower.to(".cover--x", { rotate: 180 });

  ScrollTrigger.create({
    trigger: ".marquee--container:not(.marquee--container_sm)",
    start: "top bottom-=20%",
    end: "top 30%",
    onUpdate: (self) => {
      gsap.to(".marquee--container:not(.marquee--container_sm)", {
        x:
          (window.innerWidth - self.trigger.getBoundingClientRect().width) *
          self.progress,
      });
    },
  });

  ScrollTrigger.create({
    trigger: ".marquee--container_sm",
    start: "top bottom-=20%",
    end: "top 30%",
    onUpdate: (self) => {
      gsap.to(".marquee--container_sm", {
        x:
          (window.innerWidth - self.trigger.getBoundingClientRect().width) *
          (1 - self.progress),
      });
    },
  });

  gsap.utils.toArray(".workworkworkworkworkwork--list img").forEach((el) => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "top center",
        scrub: 1,
      },
      y: 50,
      opacity: 0,
      duration: 1,
      ease: "power4.inOut",
      stagger: 0.1,
    });
  });

  const footerButton = document.querySelector(".footer--content a");
  const buttonArrow = footerButton.querySelector("span");
  footerButton.addEventListener("mouseenter", () => {
    gsap.to(buttonArrow, {
      x: 10,
      duration: 0.2,
      ease: "power4.in",
    });
  });
  footerButton.addEventListener("mouseleave", () => {
    gsap.to(buttonArrow, {
      x: 0,
      duration: 0.6,
      ease: "power4.out",
    });
  });

  const contactButton = document.querySelector(".contact");
  const contactButtonCircle = contactButton.querySelector("circle");
  const contactButtonIcon = contactButton.querySelector(".contact--icon");
  const contactButtonText = contactButton.querySelector(".contact--text");
  contactButton.addEventListener("mouseenter", () => {
    gsap.to(contactButtonIcon, {
      rotateZ: "+=30",
      transformOrigin: "center",
      duration: 1.5,
      ease: "elastic.inOut(1, 0.3)",
    });
    gsap.to(contactButtonText, {
      rotate: 720,
      duration: 0.66,
      ease: "power4.inOut",
    });
  });
  contactButton.addEventListener("mouseleave", () => {
    gsap.set(contactButtonIcon, {
      scale: 1,
      x: 0,
      y: 0,
      delay: 0.17,
      ease: "power4.inOut",
    });
    gsap.to(contactButtonText, {
      rotate: 359,
      duration: 1.2,
      ease: "power4.inOut",
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const svg = `<svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.338 19.483c0 .272.35.562 1.047.872.737.31 1.533.464 2.386.464.853 0 1.707-.135 2.56-.406s1.804-.407 2.85-.407c1.591 0 2.949.465 4.073 1.394 1.164.93 1.746 2.304 1.746 4.124 0 1.317-.485 2.517-1.454 3.602-.931 1.084-2.192 1.626-3.782 1.626-1.63 0-2.948-.523-3.957-1.568a16.247 16.247 0 0 1-2.443-3.427c-.66-1.278-1.242-2.44-1.746-3.485-.465-1.046-1.028-1.569-1.687-1.569-.194 0-.33.078-.407.233-.078.154-.117.387-.117.697 0 1.084.252 1.974.757 2.671a25.44 25.44 0 0 0 1.687 1.975c.62.62 1.183 1.336 1.687 2.15.504.813.757 1.916.757 3.31 0 1.317-.427 2.517-1.28 3.602-.815 1.084-2.153 1.626-4.015 1.626-1.862 0-3.22-.542-4.073-1.626-.814-1.085-1.221-2.285-1.221-3.602 0-1.394.252-2.497.756-3.31.477-.78 1.044-1.5 1.687-2.15a25.448 25.448 0 0 0 1.687-1.974c.505-.698.757-1.588.757-2.672 0-.31-.04-.543-.117-.697-.077-.155-.213-.233-.407-.233-.66 0-1.241.523-1.745 1.569a68.033 68.033 0 0 1-1.688 3.485 15.227 15.227 0 0 1-2.502 3.427c-.97 1.045-2.269 1.568-3.898 1.568-1.59 0-2.87-.542-3.84-1.626C4.466 28.04 4 26.84 4 25.524c0-1.82.562-3.194 1.687-4.124 1.164-.93 2.54-1.394 4.131-1.394 1.047 0 1.998.136 2.851.407.827.267 1.69.404 2.56.406.853 0 1.63-.155 2.327-.464.737-.31 1.106-.6 1.106-.872 0-.27-.369-.561-1.106-.87-.698-.35-1.474-.524-2.327-.524s-1.707.136-2.56.407c-.853.271-1.803.407-2.85.407-1.591 0-2.968-.465-4.132-1.394C4.562 16.579 4 15.205 4 13.385c0-1.317.465-2.517 1.396-3.602.97-1.084 2.25-1.626 3.84-1.626 1.63 0 2.929.542 3.899 1.626a15.223 15.223 0 0 1 2.501 3.427 46.821 46.821 0 0 1 1.688 3.485c.504 1.046 1.086 1.569 1.745 1.569.194 0 .33-.078.407-.233.078-.155.117-.406.117-.755 0-1.084-.252-1.955-.757-2.614a16.235 16.235 0 0 0-1.687-1.974 13.832 13.832 0 0 1-1.687-2.208c-.504-.813-.757-1.897-.757-3.252 0-1.317.408-2.517 1.222-3.602C16.781 2.542 18.138 2 20 2c1.862 0 3.2.542 4.014 1.626.854 1.085 1.28 2.285 1.28 3.602 0 1.355-.252 2.44-.756 3.252-.487.79-1.052 1.53-1.687 2.208-.62.62-1.183 1.277-1.687 1.974-.505.659-.757 1.53-.757 2.614 0 .349.04.6.117.755.077.155.213.233.407.233.66 0 1.222-.523 1.687-1.569a72.841 72.841 0 0 1 1.746-3.485 16.247 16.247 0 0 1 2.443-3.427c1.009-1.084 2.328-1.626 3.957-1.626 1.59 0 2.85.542 3.782 1.626.97 1.085 1.454 2.285 1.454 3.602 0 1.82-.582 3.194-1.746 4.124-1.124.929-2.482 1.394-4.072 1.394-1.047 0-1.998-.136-2.851-.407a8.413 8.413 0 0 0-2.56-.407 5.52 5.52 0 0 0-2.386.523c-.698.31-1.047.6-1.047.871Z" fill="#FEC4C6"/></svg>`;

  const url = `data:image/svg+xml;base64,${btoa(svg)}`;
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/svg+xml";
  link.rel = "icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
  let rotation = { value: 0 };

  window.addEventListener("scroll", function () {
    const h = document.documentElement,
      b = document.body;
    const percent =
      (h.scrollTop || b.scrollTop) /
      ((h.scrollHeight || b.scrollHeight) - h.clientHeight);
    const targetRotation = 720 * percent;

    gsap.to(rotation, {
      value: targetRotation,
      duration: 0.1,
      onUpdate: () => {
        const rotatedSvg = svg.replace(
          "<svg ",
          `<svg style="transform: rotate(${rotation.value}deg);" `
        );
        link.href = `data:image/svg+xml;base64,${btoa(rotatedSvg)}`;
      },
    });
  });
});

window.addEventListener("load", () => {
  Crisp.configure("53584017-6435-4a65-a0de-affc6db1814a");
  Crisp.chat.hide();
  Crisp.chat.onChatClosed(() => {
    Crisp.chat.hide();
  });
});

function openCrisp() {
  Crisp.chat.show();
  Crisp.chat.open();
}

window.openCrisp = openCrisp;
